module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-using-vux-loader-28.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-using-vux-loader.md
// module id = 603
// module chunks = 174